
function priceTag(value) {
  if (value) {
    const priceStr = value.toLocaleString();
    return `${priceStr}`;
  } else {
    return '';
  }
}

export default {
  get priceTag() {
    return priceTag;
  }
};



// WEBPACK FOOTER //
// ./src/utils/utils.js